(function () {
  function init() {
    let active = null;
    let opener = null;
    let bodyOverflow = '';
    const focusable = 'button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

    // Some product rich-text guides are entered as pipe-separated rows. Preserve
    // the merchant's exact values while presenting an actual, readable table.
    function formatSizeTable(modal) {
      if (!modal.hasAttribute('data-size-guide')) return;
      modal.querySelectorAll('.modal-body p').forEach(p => {
        if (Array.from(p.children).some(child => child.tagName !== 'BR')) return;
        const text = Array.from(p.childNodes).map(n => n.nodeName === 'BR' ? '\n' : n.textContent).join('');
        const rows = text.trim().split(/\r?\n/).map(line => line.trim()).filter(Boolean).map(line => line.split('|').map(cell => cell.trim()));
        if (rows.length < 3 || rows[0].length < 2 || rows.some(row => row.length !== rows[0].length || row.some(cell => !cell))) return;
        const table = document.createElement('table');
        table.className = 'cb-size-table';
        const head = table.createTHead();
        const body = table.createTBody();
        rows.forEach((row, rowIndex) => {
          const tr = (rowIndex ? body : head).insertRow();
          row.forEach((value, columnIndex) => {
            const cell = document.createElement(!rowIndex || !columnIndex ? 'th' : 'td');
            if (cell.tagName === 'TH') cell.scope = rowIndex ? 'row' : 'col';
            cell.textContent = value;
            tr.appendChild(cell);
          });
        });
        p.replaceWith(table);
      });
    }

    function close() {
      if (!active) return;
      active.classList.remove('active');
      active.style.display = 'none';
      if (opener) opener.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = bodyOverflow;
      active = null;
      if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    }

    document.querySelectorAll('[data-modal-trigger]').forEach(trigger => {
      trigger.addEventListener('click', () => {
        const modal = document.getElementById('modal-' + trigger.dataset.modalTrigger);
        if (!modal) return;
        if (active) close();
        active = modal;
        opener = trigger;
        bodyOverflow = document.body.style.overflow;
        formatSizeTable(modal);
        trigger.setAttribute('aria-expanded', 'true');
        modal.style.display = 'flex';
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
        (modal.querySelector('.modal-close') || modal).focus({ preventScroll: true });
      });
    });
    // Product modals are appended by a DOMContentLoaded callback, which can
    // run after this deferred script initializes. Delegate clicks so newly
    // inserted close buttons and backdrops always work.
    document.addEventListener('click', event => {
      if (!active) return;
      const closeButton = event.target.closest && event.target.closest('.modal-close');
      if (event.target === active || (closeButton && active.contains(closeButton))) close();
    });
    document.addEventListener('keydown', event => {
      if (!active) return;
      if (event.key === 'Escape') { event.preventDefault(); close(); return; }
      if (event.key !== 'Tab') return;
      const controls = Array.from(active.querySelectorAll(focusable)).filter(el => !el.disabled && el.getClientRects().length);
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (!first) { event.preventDefault(); active.focus(); return; }
      if (event.shiftKey && (document.activeElement === first || !active.contains(document.activeElement))) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !active.contains(document.activeElement))) {
        event.preventDefault(); first.focus();
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
